import React, { Component } from "react";
import FlexView from "react-flexview";
import SimpleButton from "../../../modules/commons/SimpleButton";
import Api from "../../../Services/Api";
import { mapToObjectDDL } from "../../common/mapper";
import * as R from "ramda";
import SimpleDDL from "../../../modules/SimpleDDL";
import SimpleInput from "../../../modules/SimpleInput";
import M from "moment";
import SimpleModal from "../../../modules/popup/SimpleModal";
import ModalContainer from "../../../modules/commons/ModalContainer";
import SimpleDate from "../../../modules/SimpleDate";
import {contructQueryParam, fetchDataAsync} from "../../../Services/Utils";

class MasterUnitPriceFilter extends Component {
  constructor(props) {
    super(props); //kodeCabang submittedFilter viewModals
    this.state = {
      dataVariant: [],
      dataMainDealer: [],
      temporaryFilter: {},
      warningMessage: "",
    };
  }

  async componentDidMount() {
      const [responseMainDealer, responseVariant] = await Promise.all([
        fetchDataAsync({
          asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllSupplierMainDealer,
          menuName: "Master Unit Price",
          setError: this.props.setError,
          args: contructQueryParam({kodeCabang: this.props.selectedCabang.value}),
        }),
        fetchDataAsync({
          asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllVariant,
          menuName: "Master Unit Price",
          setError: this.props.setError,
        }),
      ]);
      if (responseMainDealer.ok && !R.isEmpty(responseMainDealer.data.data)) {
        if (Object.keys(this.props.temporaryFilter).length !== 0) {
          this.setState((prevValue) => ({
            ...prevValue,
            dataMainDealer: responseMainDealer.data.data.map((c) =>
              mapToObjectDDL(c.supplierName, c.supplierCode)
            ),
            temporaryFilter: this.props.temporaryFilter,
            dataVariant: responseVariant.data.data.map((c) =>
              mapToObjectDDL(c.namaVariant, c.kodeVariant)
            ),
          }));
        } else {
          this.setState((prevValue) => ({
            ...prevValue,
            dataMainDealer: responseMainDealer.data.data.map((c) =>
              mapToObjectDDL(c.supplierName, c.supplierCode)
            ),
            dataVariant: responseVariant.data.data.map((c) =>
              mapToObjectDDL(c.namaVariant, c.kodeVariant)
            ),
          }));
        }
      }
  }

  handleReset = () => {
    this.setState((prevState) => ({
      ...prevState,
      temporaryFilter: {},
    }));
    this.props.onReset();
  };

  handleValueChange = (input, event) => {
    const value = Array.isArray(event)
      ? event.map((item) => item.value)
      : event
      ? event.value
      : "";
    this.setState((prevState) => ({
      ...prevState,
      temporaryFilter: {
        ...prevState.temporaryFilter,
        [input]: value,
      },
    }));
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.onSubmit(this.state.temporaryFilter);
  };

  handleInputDateChange = (name, value) => {
    this.setState(
      (prevState) => ({
        ...prevState,
        temporaryFilter: {
          ...prevState.temporaryFilter,
          [name]: M(value).format("DD-MM-YYYY"),
        },
        warningMessage: "",
      }),
      () => {
        const { fromDate, toDate } = this.state.temporaryFilter;
        const parsedFromDate = fromDate
          ? M(fromDate, "DD-MM-YYYY").toDate()
          : null;
        const parsedToDate = toDate ? M(toDate, "DD-MM-YYYY").toDate() : null;

        if (
          name === "toDate" &&
          parsedFromDate &&
          parsedToDate &&
          parsedToDate < parsedFromDate
        ) {
          this.setState({
            warningMessage:
              "Tanggal akhir tidak boleh lebih kecil dari tanggal awal.",
          });
        }

        if (
          name === "fromDate" &&
          parsedFromDate &&
          parsedToDate &&
          parsedToDate < parsedFromDate
        ) {
          this.setState({
            warningMessage:
              "Tanggal akhir tidak boleh lebih kecil dari tanggal awal.",
          });
        }
      }
    );
  };

  findLabel = (value, options) => {
    if (!value || options.length === 0) return "";

    if (Array.isArray(value)) {
      return value
        .map((v) => options.find((option) => option.value === v))
        .filter(Boolean);
    }

    const label = options.find((option) => option.value === value);
    return label ? label : "";
  };

  render() {
    const { kodeCabang } = this.props;
    return (
      <SimpleModal
        title="Filter Unit Motor"
        visible={this.props.visible}
        onClickClose={this.props.onClickClose}
        content={
          <ModalContainer>
            <SimpleInput
              id="input_text_kode_document"
              name="kodeDocument"
              label="Kode Dokumen"
              value={this.state.temporaryFilter.kodeDocument || ""}
              onChange={(e) => {
                this.handleValueChange("kodeDocument", e.target);
              }}
            />
            <FlexView
              vAlignContent="center"
              style={{ alignItems: "center" }}
              marginBottom={10}
              marginTop={15}
            >
              <p
                className="margin-bottom-20px margin-right-10px"
                fontSize="5px"
                style={{ textAlign: "center" }}
              >
                Tanggal Berlaku
              </p>
              <SimpleDate
                id="select_date_from"
                onChange={(value) =>
                  this.handleInputDateChange("fromDate", value)
                }
              />
              <p
                className="margin-bottom-20px margin-right-10px margin-left-10px"
                style={{ textAlign: "center" }}
              >
                -
              </p>
              <SimpleDate
                id="select_date_to"
                onChange={(value) =>
                  this.handleInputDateChange("toDate", value)
                }
              />
            </FlexView>
            {this.state.warningMessage && (
              <p style={{ color: "red", marginTop: "10px" }}>
                {this.state.warningMessage}
              </p>
            )}
            <SimpleDDL
              id="input_text_kode_main_dealer"
              name="kodeMainDealer"
              label="Kode Main Dealer"
              box="search"
              isClearable
              options={this.state.dataMainDealer}
              value={
                this.findLabel(
                  this.state.temporaryFilter.kodeMainDealer,
                  this.state.dataMainDealer || []
                ) || ""
              }
              onChange={(e) => this.handleValueChange("kodeMainDealer", e)}
            />
            <SimpleDDL
              id="input_select_kode_cabang"
              name="kodeCabang"
              label="Cabang Berlaku"
              box="multiselect"
              isClearable
              options={kodeCabang}
              value={
                this.findLabel(
                  this.state.temporaryFilter.kodeCabang,
                  kodeCabang || []
                ) || ""
              }
              onChange={(e) => this.handleValueChange("kodeCabang", e)}
            />
            <SimpleDDL
              id="input_select_kode_variant"
              name="kodeVariant"
              label="Varian"
              box="multiselect"
              isClearable
              options={this.state.dataVariant || []}
              value={
                this.findLabel(
                  this.state.temporaryFilter.kodeVariant,
                  this.state.dataVariant || []
                ) || ""
              }
              onChange={(e) => this.handleValueChange("kodeVariant", e)}
            />
            <FlexView hAlignContent="right">
              <SimpleButton type="button" secondary onClick={this.handleReset}>
                Hapus
              </SimpleButton>
              <SimpleButton type="button" onClick={this.handleSubmit}>
                Terapkan
              </SimpleButton>
            </FlexView>
          </ModalContainer>
        }
      />
    );
  }
}

export default MasterUnitPriceFilter;
